import { render, staticRenderFns } from "./ChatButton.vue?vue&type=template&id=6f167fc1&"
import script from "./ChatButton.vue?vue&type=script&lang=js&"
export * from "./ChatButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports